module.exports = __webpack_public_path__ + "../resources/img/ic-minus.84a380d6.svg";